import { types, Instance } from 'mobx-state-tree';
const { model, string, maybeNull, maybe, number } = types;

export const syncMicrosoftUserModel = model('syncMicrosoftUserModel ', {
  mail: maybeNull(string),
  surname: maybeNull(string),
  givenName: maybeNull(string),
  displayName: maybe(string),
  description: maybe(string),
  mobilePhone: maybeNull(string),
  officeLocation: maybeNull(string),
  userPrincipalName: string,
  preferredLanguage: maybeNull(string),
  jobTitle: maybeNull(string),
  createdDateTime: maybeNull(string),
  microsoftId: maybeNull(string),
});
export type IsyncMicrosoftUserModel = Instance<typeof syncMicrosoftUserModel>;

export const syncMicrosoftGroupModel = model('syncMicrosoftGroupModel', {
  createdDateTime: maybeNull(string),
  description: maybeNull(string),
  displayName: maybeNull(string),
  expirationDateTime: maybeNull(string),
  email: maybeNull(string),
  mail: maybeNull(string),
  microsoftId: maybeNull(string),
});
export type IsyncMicrosoftGroupModel = Instance<typeof syncMicrosoftGroupModel>;

export const StatisticModel = model('StatisticModel', {
  user: number,
  group: number,
  department: number,
});
export type IStatisticModel = Instance<typeof StatisticModel>;
